import { render, staticRenderFns } from "./SectionTicketFields.vue?vue&type=template&id=95578e24&scoped=true&"
import script from "./SectionTicketFields.vue?vue&type=script&lang=js&"
export * from "./SectionTicketFields.vue?vue&type=script&lang=js&"
import style0 from "./SectionTicketFields.vue?vue&type=style&index=0&id=95578e24&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95578e24",
  null
  
)

export default component.exports